import * as React from 'react';

// Components
import NebulaLoading from '@nebula/loading';

// Constants
import { Theme } from '@shopee-user/business-customization-logic';

export default function LoadingIndicator({
  className,
}: {
  className?: string;
}): JSX.Element {
  return <NebulaLoading className={className} color={Theme.ColorPrimary} />;
}
